module.exports = __webpack_public_path__ + "img/zxitemimg4.94d573fd.png";